import { render } from "./rest.vue?vue&type=template&id=0bede7cc&scoped=true"
import script from "./rest.vue?vue&type=script&lang=js"
export * from "./rest.vue?vue&type=script&lang=js"

import "./rest.vue?vue&type=style&index=0&id=0bede7cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bede7cc"]])

export default __exports__